module.exports = __webpack_public_path__ + "20caf2dba6111200c36702d50a77d4a4.svg";